var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCardOne(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 62,
    viewBox: "0 0 62 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_2279_5696)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 2,
    width: 56,
    height: 56,
    rx: 11.6667,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 24.5C22 22.567 23.567 21 25.5 21C27.433 21 29 22.567 29 24.5V26H33V24.5C33 22.567 34.567 21 36.5 21C38.433 21 40 22.567 40 24.5C40 26.433 38.433 28 36.5 28H35V32H36.5C38.433 32 40 33.567 40 35.5C40 37.433 38.433 39 36.5 39C34.567 39 33 37.433 33 35.5V34H29V35.5C29 37.433 27.433 39 25.5 39C23.567 39 22 37.433 22 35.5C22 33.567 23.567 32 25.5 32H27V28H25.5C23.567 28 22 26.433 22 24.5ZM27 26V24.5C27 23.6716 26.3284 23 25.5 23C24.6716 23 24 23.6716 24 24.5C24 25.3284 24.6716 26 25.5 26H27ZM29 28V32H33V28H29ZM27 34H25.5C24.6716 34 24 34.6716 24 35.5C24 36.3284 24.6716 37 25.5 37C26.3284 37 27 36.3284 27 35.5V34ZM35 34V35.5C35 36.3284 35.6716 37 36.5 37C37.3284 37 38 36.3284 38 35.5C38 34.6716 37.3284 34 36.5 34H35ZM35 26H36.5C37.3284 26 38 25.3284 38 24.5C38 23.6716 37.3284 23 36.5 23C35.6716 23 35 23.6716 35 24.5V26Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_2279_5696",
    x: 0.666667,
    y: 0.833333,
    width: 60.6667,
    height: 60.6667,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1.16667,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_2279_5696"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2279_5696"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.16667
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.16667
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_2279_5696",
    result: "effect2_dropShadow_2279_5696"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_2279_5696",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardOne);
export default __webpack_public_path__ + "static/media/card-one.2b443e9ace3aaead02566261915b8663.svg";
export { ForwardRef as ReactComponent };